export enum CancelationEmailDialogFormLabelsEnum {
  TITLE = 'Cancelation Email',
  SEND = 'Send',
  SKIP = 'Skip',
  CANCEL = 'Cancel',
}
